import { useQuery, useMutation } from '@tanstack/react-query';
import productCategoryService from 'api/productCategoryService';

// Update the hook to accept params
export const useProductCategories = (params = {}) => {
    return useQuery({
        // 1. Add params to the queryKey so React Query tracks changes
        queryKey: ['productCategories', params],

        // 2. Pass those params into the service call
        queryFn: () => productCategoryService.all(params),

        staleTime: 10 * 60 * 1000
    });
};

export const useProductCategoriesForSelection = (params = {}) => {
    return useQuery({
        queryKey: ['productCategoriesSelection', params],
        queryFn: () => productCategoryService.selectCategories(params),
        staleTime: 10 * 60 * 1000
    });
};

export const useProductCategory = (id) => {
    return useQuery({
        queryKey: ['productCategory', id],
        queryFn: () => productCategoryService.get(id),
        enabled: !!id, // only run if id is provided
        staleTime: 10 * 60 * 1000 // cache for 10 mins
    });
};

// Admin only hooks
export const useCreateProductCategory = (options) => {
    return useMutation({
        mutationFn: productCategoryService.create,
        ...options
    });
};

export const useUpdateProductCategory = (options) => {
    return useMutation({
        mutationFn: ({ id, ...data }) => productCategoryService.update(id, data),
        ...options
    });
};

export const useDeleteProductCategory = (options) => {
    return useMutation({
        mutationFn: (id) => productCategoryService.delete(id),
        ...options
    });
};
